export default __webpack_public_path__ + "static/media/north.bb9f5f30.svg";